export const PARTNERS_OPTIONS = [
  "name",
  "inn",
  "country",
  "fo",
  "region",
  "city",
  "address",
  "status",
  "createdAt",
  "author",
  "updatedAt",
];
